import React from "react";
import {
  DndContext,
  closestCenter,
} from "@dnd-kit/core";

import {
  SortableContext,
  rectSortingStrategy,
} from "@dnd-kit/sortable";

import DraggableDayCard from "./DraggableDayCard";
import { useReorder } from "./useReorder";

const ReorderModal = ({
  open,
  onClose,
  items,
  setItems,
  onSave,
  saving,
}) => {

  const { sensors, handleDragEnd } = useReorder(setItems);

  if (!open) return null;

  return (
 <div className="absolute right-0 mt-3 w-[320px] sm:w-[420px] bg-white border border-gray-100 rounded-2xl shadow-xl z-50 p-4 animate-fade-in">

  {/* POPUP CARD */}
  <div className="w-full max-w-md sm:max-w-lg bg-white rounded-3xl shadow-2xl border border-gray-100 p-5 sm:p-6 animate-fade-in">

    {/* HEADER */}
    <div className="flex items-center justify-between mb-5">
      <h3 className="text-base sm:text-lg font-bold text-gray-900">
        Reorder Days
      </h3>

      <button
        onClick={onClose}
        className="w-8 h-8 flex items-center justify-center rounded-lg hover:bg-gray-100 text-gray-400 hover:text-gray-700 transition"
      >
        ✕
      </button>
    </div>

    {/* GRID */}
    <div className="max-h-[60vh] overflow-y-auto pr-1">
      <DndContext
        sensors={sensors}
        collisionDetection={closestCenter}
        onDragEnd={handleDragEnd}
      >
        <SortableContext
          items={items.map(d => d._id)}
          strategy={rectSortingStrategy}
        >
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
            {items.map((day) => (
              <DraggableDayCard key={day._id} id={day._id} day={day} />
            ))}
          </div>
        </SortableContext>
      </DndContext>
    </div>

    {/* ACTIONS */}
    <div className="flex justify-end gap-3 mt-5 pt-4 border-t border-gray-100">
      <button
        onClick={onClose}
        className="px-4 py-2 text-sm font-semibold text-gray-500 hover:text-gray-800 transition"
      >
        Cancel
      </button>

      <button
        onClick={onSave}
        className="px-5 py-2 bg-[#5b6f00] text-white text-sm font-semibold rounded-xl hover:bg-[#4a5a00] active:scale-[0.98] transition"
      >
        {saving ? "Saving..." : "Save"}
      </button>
    </div>

  </div>
</div>
  );
};

export default ReorderModal;